import { useParams } from 'next/navigation';

import { useCurrentBot } from '~hooks/useCurrentBot';
import { ImageRenderer } from '~shared/ui/molecules';

import {
	AllContainer,
	BotAvatar,
	BotAvatarContainer,
	ImageContainer,
} from './styles';

export const BotChatBackgroundImage = () => {
	const { recipientId = '' } = useParams<{ recipientId?: string }>();
	const { bot, botSuccess } = useCurrentBot({
		recipientId,
	});

	return botSuccess && bot.images?.webBackgroundPath ? (
		<BotAvatarContainer>
			<AllContainer>
				<ImageContainer>
					<ImageRenderer
						className={BotAvatar}
						item={bot.images?.webBackgroundLinks}
						fallback={bot.images?.webBackgroundPath}
						fill={true}
						alt={bot.name}
						priority={true}
						quality={100}
					/>
				</ImageContainer>
			</AllContainer>
		</BotAvatarContainer>
	) : null;
};
